"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormModes = exports.FormFieldTypesNames = exports.FormFieldTypes = exports.FieldModes = void 0;
// have to check and keep
let FormFieldTypesNames = exports.FormFieldTypesNames = /*#__PURE__*/function (FormFieldTypesNames) {
  FormFieldTypesNames["TEXT_INPUT"] = "Short Text";
  FormFieldTypesNames["TEXT_AREA"] = "Long Text";
  FormFieldTypesNames["MULTIPLE_CHOICES"] = "Choices";
  FormFieldTypesNames["DROPDOWN"] = "Dropdown";
  FormFieldTypesNames["DATE_INPUT"] = "Date";
  FormFieldTypesNames["TIME_PICKER"] = "Time";
  FormFieldTypesNames["LINEAR_SCALING"] = "Slider";
  FormFieldTypesNames["FILE_UPLOAD"] = "File Upload";
  FormFieldTypesNames["CURRENCY"] = "Currency";
  FormFieldTypesNames["RATING"] = "Rating";
  FormFieldTypesNames["DESCRIPTION"] = "Rich Text";
  FormFieldTypesNames["NUMBER_INPUT"] = "Number";
  FormFieldTypesNames["DATE_TIME_PICKER"] = "Date & Time";
  FormFieldTypesNames["CHECK_BOX"] = "Decision Box";
  FormFieldTypesNames["DECIMAL"] = "Decimal";
  FormFieldTypesNames["DECISION_BOX"] = "Decision Box";
  FormFieldTypesNames["CALCULATIVE"] = "Formula";
  FormFieldTypesNames["PAGE_BREAK"] = "Page Break";
  FormFieldTypesNames["PAYMENT"] = "Payment";
  FormFieldTypesNames["BLANK_BOX"] = "Empty space";
  return FormFieldTypesNames;
}({});
let FormFieldTypes = exports.FormFieldTypes = /*#__PURE__*/function (FormFieldTypes) {
  FormFieldTypes["TEXT_INPUT"] = "TEXT_INPUT";
  FormFieldTypes["TEXT_AREA"] = "TEXT_AREA";
  FormFieldTypes["MULTIPLE_CHOICES"] = "MULTIPLE_CHOICES";
  FormFieldTypes["DROPDOWN"] = "DROPDOWN";
  FormFieldTypes["DATE_INPUT"] = "DATE_INPUT";
  FormFieldTypes["TIME_PICKER"] = "TIME_PICKER";
  FormFieldTypes["LINEAR_SCALING"] = "LINEAR_SCALING";
  FormFieldTypes["FILE_UPLOAD"] = "FILE_UPLOAD";
  FormFieldTypes["CURRENCY"] = "CURRENCY";
  FormFieldTypes["RATING"] = "RATING";
  FormFieldTypes["DATE_TIME_PICKER"] = "DATE_TIME_PICKER";
  FormFieldTypes["CHECK_BOX"] = "CHECK_BOX";
  FormFieldTypes["NUMBER_INPUT"] = "NUMBER_INPUT";
  FormFieldTypes["DECIMAL"] = "DECIMAL";
  FormFieldTypes["DECISION_BOX"] = "DECISION_BOX";
  FormFieldTypes["CALCULATIVE"] = "CALCULATIVE";
  FormFieldTypes["PAGE_BREAK"] = "PAGE_BREAK";
  FormFieldTypes["PAYMENT"] = "PAYMENT";
  FormFieldTypes["DESCRIPTION"] = "DESCRIPTION";
  FormFieldTypes["BLANK_BOX"] = "BLANK_BOX";
  FormFieldTypes["SECTION"] = "SECTION";
  FormFieldTypes["YEAR_SELECTOR"] = "YEAR_SELECTOR";
  FormFieldTypes["PINCODE"] = "PIN_CODE";
  FormFieldTypes["LOOKUP"] = "LOOKUP";
  return FormFieldTypes;
}({});
let FormModes = exports.FormModes = /*#__PURE__*/function (FormModes) {
  FormModes["view"] = "VIEW";
  FormModes["edit"] = "EDIT";
  FormModes["preview"] = "PREVIEW";
  FormModes["responseView"] = "RESPONSEVIEW";
  return FormModes;
}({});
let FieldModes = exports.FieldModes = /*#__PURE__*/function (FieldModes) {
  FieldModes["view"] = "VIEW";
  FieldModes["edit"] = "EDIT";
  return FieldModes;
}({});